<template>
  <el-container>
    <el-aside>
        <div v-if="course.logo" class="logo">
          <img :src="course.logo" alt="Logo">
        </div>
        <el-collapse v-model="sidebar" accordion>
          <el-collapse-item
            v-for="(module, index) in course.modules"
            :key="index"
            :name="`module-${index + 1}`"
            :title="module.title">
            <router-link
              v-for="(step, sindex) in module.steps"
              :key="sindex"
              :to="`/module-${index + 1}/step-${sindex + 1}`">
              {{ step.title }}
            </router-link>
          </el-collapse-item>
        </el-collapse>
        <el-row v-if="!isEmbed" class="logout">
          <el-col>
            <router-link to="/logout">
              <el-button plain round>Logout</el-button>
            </router-link>
          </el-col>
        </el-row>

      </el-aside>
      <el-main>
        <el-row>
          <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="18">
            <div class="course">
              <div class="title">{{ step.title }}</div>
              <div v-if="step.video && videoIsUrl" class="video">
                <iframe
                  :src="step.video"
                  width="560"
                  height="315"
                  frameborder="0"
                  allowfullscreen/>
              </div>
              <div v-else v-html="step.video" class="video-block" />
              <div
                v-if="step.description !== '<p></p>' && step.description !== ''"
                v-html="step.description"
                class="description"/>
            </div>
          </el-col>
        </el-row>
        <div class="nav-buttons">
          <el-button type="success" round @click="prevStep">Previous</el-button>
          <el-button
            v-if="stepIndex < lastStepIndex || moduleIndex < lastModuleIndex"
            type="primary"
            round
            @click="nextStep">
            Next Lesson
          </el-button>
        </div>
      </el-main>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex';
import isUrl from 'is-url';

export default {
  data() {
    return {
      sidebar: [this.$route.params.module],
    };
  },
  created() {
    const { module, step } = this.$route.params;

    if (!module.includes('module-')) {
      this.$router.push('/module-1/step-1');
    }

    if (!step) {
      this.$router.push(`/${this.$route.params.module}/step-1`);
    }

    if (this.moduleIndex < 0 || this.moduleIndex > this.lastModuleIndex) {
      console.log(this.moduleIndex, this.lastModuleIndex);
      this.$router.push('/module-1/step-1');
    }

    if (this.stepIndex < 0 || this.stepIndex > this.lastStepIndex) {
      this.$router.push(`/${this.$route.params.module}/step-1`);
    }
  },
  computed: {
    ...mapGetters(['course']),
    isEmbed() {
      return (this.course.mode && this.course.mode === 'hash');
    },
    moduleIndex() {
      const { module } = this.$route.params;

      return Number.parseInt(module.replace('module-', ''), 10) - 1;
    },
    stepIndex() {
      const { step } = this.$route.params;
      return Number.parseInt(step.replace('step-', ''), 10) - 1;
    },
    module() {
      return this.course.modules[this.moduleIndex];
    },
    step() {
      return this.module.steps[this.stepIndex];
    },
    lastModuleIndex() {
      return this.course.modules.length - 1;
    },
    lastStepIndex() {
      if (this.module.steps) {
        return this.module.steps.length - 1;
      }

      return 0;
    },
    videoIsUrl() {
      return isUrl(this.step.video);
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.sidebar = [to.params.module];
    next();
  },
  methods: {
    prevStep() {
      if (this.stepIndex > 0) {
        this.$router.push(`/${this.$route.params.module}/step-${this.stepIndex}`);
      } else if (this.moduleIndex > 0) {
        const m = this.moduleIndex;
        this.$router.push(`/module-${m}/step-${this.course.modules[m - 1].steps.length}`);
      }
    },
    nextStep() {
      if (this.stepIndex < this.lastStepIndex) {
        this.$router.push(`/${this.$route.params.module}/step-${this.stepIndex + 2}`);
      } else if (this.moduleIndex < this.lastModuleIndex) {
        this.$router.push(`/module-${this.moduleIndex + 2}/step-1`);
      }
    },
  },
};
</script>
